import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LocalService {
  constructor(private utilities: UtilitiesService) { }

  getUrlWiki(): Observable<any> {
    const url = environment.portalURL + API_URL.WIKI_URL;
    return this.utilities.req.httpGet<any>(url);
  }
}
